<template>
    <div class="page-bg login">
        <v-container fill-height justify-center>
            <div class="login-block">
                <div class="Client-logo">
                    <img :src="logo" class="Client-logo-img" />
                </div>
                <v-form class="login-frm">
                    <v-row>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <span class="new-signup-user">Please Provide student details here</span>
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <v-text-field
                                v-model="name"
                                label="Student Name"
                                disabled
                                class="required disabled-field"
                                hide-details
                                dense
                                outlined
                            ></v-text-field>
                            <InputError :data="error.name" />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <div class="input-btn-group">
                                <v-text-field
                                    v-model="email"
                                    label="Student Email ID"
                                    class="required"
                                    hide-details
                                    dense
                                    outlined
                                ></v-text-field>
                                <v-btn
                                    color="primary"
                                    class="cust-btn"
                                    :disabled="emailUpdated"
                                    @click="getStudentName"
                                >Find</v-btn>
                            </div>
                            <InputError :data="error.email" />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <div class="signup-primary sign-up-terms top-0">
                                <div class="user-new-signup">
									<div class="user-terms-block" v-if="showPrivacyAndTerms">
										<div class="user-terms-check">
											<v-checkbox input-value="" value v-model="ischecked"></v-checkbox>
											</div>
										 <div class="user-terms-text-outer">
										<div class="user-terms-text" >
												I accept the <a @click="termandcondition">Terms of Service</a> 
												and <a @click="privacyPolicy">Privacy Policy</a>
												</div>
											</div>
											<InputError :data="error.ischecked" />
									</div>
								</div>
                                <div class="sign-up-btn">
                                    <v-btn
                                        @click="onSubmit"
                                        :disabled="disableDoneButton"
                                        class="right-btn cust-btn"
                                        color="primary"
                                    >Confirm</v-btn>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
                <div v-if="isDefaultInstitute && myInstitute && !myInstitute.is_white_labeled" class="power-logo">
                    <img src="@/assets/img/logo-footer.png" class="master-logo" />
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
    name: "ParentSignupStep2",
    data() {
        return {
            name: "",
            email: "",
			ischecked:false,
            logo: this.getInstituteLogo(),
            error: {
                name: {
                    type: null,
                    message: "Please enter name",
                },
                email: {
                    type: null,
                    message: null,
                },
				ischecked: {
					type: null,
					message: "Please accept Terms & Conditions and Privacy Policy",
				},
            },
            oldStudentEmail: null,
            disableDoneButton: true,
			showPrivacyAndTerms:true,
        };
    },
    methods: {
        ...mapActions({
            signUp: "userStore/signUp",
            getUserByEmail: "userStore/getUserByEmail",
        }),
        getStudentName() {
            this.email = this.removeWhiteSpacesFromEmail(this.email);
            this.name = "";
            this.error.email.type = null;
            this.error.email.message = null;
            this.oldStudentEmail = this.email;

            if (!this.isValidEmail(this.email)) {
                this.error.email.type = "error";
                this.error.email.message =
                    "The email ID entered by you is not a valid email ID. Please enter a valid email ID.";
                return;
            }
            let reqData = {
                email_id: this.email.trim(),
            };
            this.getUserByEmail(reqData)
                .then((response) => {
                    this.name = response.name;
                    this.disableDoneButton = false;
                })
                .catch((err) => {});
        },
        onSubmit() {
            if (this.validate()) {
                this.$root.showLoader = true;
                let details = {
                    name: this.name.trim(),
                    email: this.email.trim(),
                };

                this.signUp({ ...this.signUpData, details })
                    .then((response) => {
                        this.$root.showLoader = false;
                        this.$toasted.success(`Success\n${response.message}`, {
                            icon: "check_circle", className:'new-class'
                        });
                        this.$router.push({ name: "login" }).catch(() => {});
                    })
                    .catch((err) => {
                        this.$root.showLoader = false;
                    });
            }
        },
        validate() {
            this.email = this.removeWhiteSpacesFromEmail(this.email);
            let isValid = true;
            this.error.name.type = null;
            this.error.email.type = null;
            this.error.ischecked.type = null;

            // if (!this.name || this.name.trim().length < 1) {
            //     this.error.name.type = "error";
            //     this.error.name.message = "Please enter name";
            //     isValid = false;
            // }
            if (!this.email || this.email.length < 1) {
                this.error.email.type = "error";
                this.error.email.message = "Please enter email ID.";
                isValid = false;
            } else if (!this.isValidEmail(this.email)) {
                this.error.email.type = "error";
                this.error.email.message =
                    "The email ID entered by you is not a valid email ID. Please enter a valid email ID.";
                isValid = false;
            }
			if (!this.ischecked && this.showPrivacyAndTerms) {
				this.error.ischecked.type ='error';
				isValid = false
			}
            return isValid;
        },
		
		termandcondition(){
		let routeData = this.$router.resolve({name: 'terms-and-conditions'});
		window.open(routeData.href, '_blank');
	},
	privacyPolicy(){
		let routeData = this.$router.resolve({name: 'privacy-policy'});
		window.open(routeData.href, '_blank');
	},
    },
    computed: {
        ...mapState("userStore", ["signUpData", "isDefaultInstitute", 'myInstitute']),
        emailUpdated() {
            if (this.oldStudentEmail == this.email) {
                this.disableDoneButton = false;
                return true;
            }
            this.disableDoneButton = true;
            return false;
        },
    },
    mounted() {
        if (!this.signUpData) {
            this.$router.push({ name: "signup" });
        }
	  const instiute = JSON.parse(localStorage.getItem('myInstitute'));
	  this.showPrivacyAndTerms = !constants.CUSTOM_DOMAIN_ID.includes(instiute.id)

    },
	watch:{
		ischecked(){
			this.error.ischecked.type = null;
		}
	}
};
</script>
